'use client'
import DeskTopSolutionsTable from '../../(components)/DeskTopSolutionsTable'

const BuyerPage = () => {

  return (
    <main>
      <DeskTopSolutionsTable />
    </main>
  )
}

export default BuyerPage
